import React, { useState, useEffect } from 'react'
import {
  Document,
  Page,
  View,
  Text,
  Font,
  StyleSheet,
  Image,
  PDFDownloadLink,
} from '@react-pdf/renderer'
import { Roboto } from '../../../fonts'
import { color } from '../../../api/ColorsSector'
import { adress } from '../../../api/waterAdress'

import { getLogoUrl } from '../../../api/Logo'
import { dateNowProtocol } from '../../../api/formatDate'
import Win1Icon from '../../../images/win_1.png'
import Win2Icon from '../../../images/win_2.png'
import Win3Icon from '../../../images/win_3.png'
import { useParams } from 'react-router-dom'
import {
  deleteData,
  updateData,
  getData,
  addData,
  upsertDataTournaments,
} from '../../../api/indexedDBHandler'

Font.register({
  family: 'Roboto',
  fonts: [
    { src: Roboto.normal, fontWeight: 'normal' },
    { src: Roboto.bold, fontWeight: 'bold' },
  ],
})

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 20,
    fontFamily: 'Roboto',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    gap: 20,
  },
  logo: {
    width: 70,
    height: 'auto',
  },
  logoContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 15,
    marginTop: 20,
    marginBottom: 10,
  },
  logoSmall: {
    height: 30,
    width: 'auto',
  },
  headerTextContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  headerText: {
    fontSize: 8,
    marginVertical: 1,
    lineHeight: 1.2,
    flexGrow: 1,
    width: '75%',
    flexWrap: 'wrap',
  },
  title: {
    width: '75%',
    textAlign: 'center',
    fontSize: 14,
    marginBottom: 10,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },

  tableColHeader: {
    padding: 2,
    borderStyle: 'solid',
    borderWidth: 0.3,
    borderColor: '#000',
    justifyContent: 'center', // по вертикали
  },

  tableTextCenter: {
    fontSize: 8,
    textAlign: 'center',
  },

  tableText: {
    fontSize: 8,
  },
  tableCol: {
    borderStyle: 'solid',
    borderWidth: 0.4,
    borderColor: '#000',
    padding: 2,
    fontSize: 8,
    textAlign: 'center',
  },
  tieNote: {
    fontSize: 6,
    color: '#666',
    textAlign: 'center',
  },
})

const TournamentProtocolGroupPDF = ({
  allLogo,
  mainLogo,
  data,
  administrator,
  tournament,
  date,
  totalFishCount,
  totalWeight,
  averageFishWeight,
  biggestFish,
  isfinish,
}) => {
  function getTeamInZoneA(teams) {
    return teams.find((team) => team.zone === 'А')
  }

  function getTeamInZoneB(teams) {
    return teams.find((team) => team.zone === 'Б')
  }
  const getname = (team) => {
    console.log(team)
    const sp1sports_category = team[0]?.sports_category
      ? ' (' + team[0]?.sports_category + ')'
      : ''
    const sp1 = team[0]?.fio ? team[0]?.fio : ''

    const sp2sports_category = team[1]?.sports_category
      ? ' (' + team[1]?.sports_category + ')'
      : ''
    const sp2 = team[1]?.fio ? ', ' + team[1]?.fio : ''

    const sp3sports_category = team[2]?.sports_category
      ? ' (' + team[2]?.sports_category + ')'
      : ''
    const sp3 = team[2]?.fio ? ', ' + team[2]?.fio : ''

    return (
      sp1 +
      sp1sports_category +
      sp2 +
      sp2sports_category +
      sp3 +
      sp3sports_category
    )
  }
  Object.size = function (obj) {
    var size = 0,
      key
    for (key in obj) {
      if (obj.hasOwnProperty(key)) size++
    }
    return size
  }
  return (
    <Document style={{ margin: 40 }}>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View style={styles.header}>
          {mainLogo && <Image src={mainLogo} style={styles.logo} />}
          <View style={styles.headerTextContainer}>
            <Text style={styles.title}>{tournament.tournament_name}</Text>
            <Text style={styles.headerText}>
              Водоём:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {adress(tournament.water_id)
                  ? adress(tournament.water_id)
                  : tournament.water_body}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата проведения:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {tournament.start_date} - {tournament.end_date}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата составления:{' '}
              <Text style={{ fontWeight: 'bold' }}>{date}</Text>
            </Text>
          </View>
        </View>
        <Text
          style={{
            fontSize: 12,
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: 10,
          }}
        >
          {' '}
          ИТОГОВЫЙ ПРОТОКОЛ
          {/*  ИТОГОВЫЙ ПРОТОКОЛ */}
          {/*  ПРОТОКОЛ ТЕХНИЧЕСКИХ РЕЗУЛЬТАТОВ СОРЕВНОВАНИЙ */}
        </Text>
        <Text style={{ fontSize: 10, textAlign: 'center', marginBottom: 10 }}>
          Ловля карпа - командные соревнования (мужчины, женщины), номер-код
          дисциплины 0920021811Л
        </Text>

        <View style={{ marginTop: 10 }}>
          <View
            style={{
              flexDirection: 'row',
              borderBottomWidth: 1,
              borderBottomColor: '#f2f2f2',
              backgroundColor: '#f2f2f2',
            }}
          >
            <View style={{ width: '5%', padding: 3, borderBottomWidth: 0 }}>
              <Text
                style={{ fontSize: 8, fontWeight: 'bold', textAlign: 'center' }}
              >
                Место
              </Text>
            </View>
            <View style={{ width: '20%', padding: 3, borderBottomWidth: 0 }}>
              <Text
                style={{ fontSize: 8, fontWeight: 'bold', textAlign: 'center' }}
              >
                Команда
              </Text>
            </View>
            <View
              style={{
                width: '30%',
                padding: 3,
                borderLeftWidth: 1,
                borderLeftColor: '#000',
              }}
            >
              <Text
                style={{ fontSize: 8, fontWeight: 'bold', textAlign: 'center' }}
              >
                Группа A
              </Text>
            </View>
            <View
              style={{
                width: '30%',
                padding: 3,
                borderLeftWidth: 1,
                borderLeftColor: '#000',
              }}
            >
              <Text
                style={{ fontSize: 8, fontWeight: 'bold', textAlign: 'center' }}
              >
                Группа Б
              </Text>
            </View>
            <View
              style={{
                width: '15%',
                padding: 3,
                borderLeftWidth: 1,
                borderLeftColor: '#000',
              }}
            >
              <Text
                style={{ fontSize: 8, fontWeight: 'bold', textAlign: 'center' }}
              >
                Итог
              </Text>
            </View>
          </View>

          <View style={{ flexDirection: 'row', backgroundColor: '#f2f2f2' }}>
            <View style={{ width: '5%', padding: 3 }}></View>
            <View style={{ width: '20%', padding: 3 }}></View>
            <View style={{ width: '30%', flexDirection: 'row' }}>
              <View style={{ width: '60%', padding: 2 }}>
                <Text style={{ fontSize: 7, textAlign: 'center' }}>Пара</Text>
              </View>
              <View style={{ width: '10%', padding: 2 }}>
                <Text style={{ fontSize: 7, textAlign: 'center' }}>Сектор</Text>
              </View>
              <View style={{ width: '20%', padding: 2 }}>
                <Text style={{ fontSize: 7, textAlign: 'center' }}>Вес</Text>
              </View>
              <View style={{ width: '10%', padding: 2 }}>
                <Text style={{ fontSize: 7, textAlign: 'center' }}>Баллы</Text>
              </View>
            </View>
            <View style={{ width: '30%', flexDirection: 'row' }}>
              <View style={{ width: '60%', padding: 2 }}>
                <Text style={{ fontSize: 7, textAlign: 'center' }}>Пара</Text>
              </View>
              <View style={{ width: '10%', padding: 2 }}>
                <Text style={{ fontSize: 7, textAlign: 'center' }}>Сектор</Text>
              </View>
              <View style={{ width: '20%', padding: 2 }}>
                <Text style={{ fontSize: 7, textAlign: 'center' }}>Вес</Text>
              </View>
              <View style={{ width: '10%', padding: 2 }}>
                <Text style={{ fontSize: 7, textAlign: 'center' }}>Баллы</Text>
              </View>
            </View>
            <View style={{ width: '15%', flexDirection: 'row' }}>
              <View style={{ width: '50%', padding: 2 }}>
                <Text style={{ fontSize: 7, textAlign: 'center' }}>Вес</Text>
              </View>
              <View style={{ width: '50%', padding: 2 }}>
                <Text style={{ fontSize: 7, textAlign: 'center' }}>Баллы</Text>
              </View>
            </View>
          </View>

          {data.map((item, index) => {
            console.log('itemitemitemitemitemitem', item)
            if (Object.size(item.athletesByZone) == 1) return
            else
              console.log(
                'item.athletesByZone.length',
                item.athletesByZone.length
              )
            const teamA = item.teams?.[0] || {
              sector: '-',
              weight: 0,
              place: 0,
              sp: getname(item.athlete),
            }
            console.log('itemююююююю', item)
            const zoneA = item.athletesByZone?.['А'] || [] // getTeamInZoneA(item.teams) || []
            console.log('zoneA', zoneA)

            // console.log(item.teams?.[1])
            const zoneB = item.athletesByZone?.['Б'] || []
            const teamB = item.teams?.[1] || {
              sector: '-',
              weight: 0,
              place: 0,
              sp: getname(item.athlete),
            }
            console.log('zoneB', zoneB)
            // Проверка на команды без рыбы
            const noFishCaught = teamA.weight === 0 && teamB.weight === 0
            const backgroundColor = noFishCaught
              ? '#fff'
              : item.finalPlace < 4
                ? '#8FBC8F'
                : '#fff'

            return (
              <View
                key={index}
                style={{
                  flexDirection: 'row',
                  textAlign: 'center',
                  borderBottomWidth: 0.5,
                  borderBottomColor: '#000',
                  backgroundColor,
                }}
              >
                <View
                  style={{ width: '5%', padding: 2, justifyContent: 'center' }}
                >
                  {isfinish && item.finalPlace === 1 && (
                    <Image src={Win1Icon} style={{ width: 13, height: 13 }} />
                  )}
                  {isfinish && item.finalPlace === 2 && (
                    <Image src={Win2Icon} style={{ width: 13, height: 13 }} />
                  )}
                  {isfinish && item.finalPlace === 3 && (
                    <Image src={Win3Icon} style={{ width: 13, height: 13 }} />
                  )}
                  {(!isfinish || item.finalPlace > 3) && (
                    <Text style={{ fontSize: 8, fontWeight: 'bold' }}>
                      {noFishCaught ? data.length : item.finalPlace}
                    </Text>
                  )}
                </View>

                <View style={{ width: '20%', textAlign: 'left', padding: 2 }}>
                  <Text style={{ fontSize: 8 }}>{item.team || '-'}</Text>
                </View>

                <View style={{ width: '30%', flexDirection: 'row' }}>
                  <View style={{ width: '60%', padding: 2 }}>
                    <Text style={{ fontSize: 8, textAlign: 'left' }}>
                      {zoneA[0].sp}
                      {/* {zoneA
                        .map((a) => a.strName)
                        .filter(Boolean)
                        .join(', ')} */}
                    </Text>
                  </View>
                  <View style={{ width: '10%', padding: 2 }}>
                    <Text style={{ fontSize: 8, textAlign: 'center' }}>
                      {zoneA[0].sector}
                    </Text>
                  </View>
                  <View style={{ width: '20%', padding: 2 }}>
                    <Text style={{ fontSize: 8, textAlign: 'center' }}>
                      {zoneA[0].totalWeight}
                    </Text>
                  </View>
                  <View style={{ width: '10%', padding: 2 }}>
                    <Text style={{ fontSize: 8, textAlign: 'center' }}>
                      {noFishCaught ? data.length : zoneA[0].zonePlace}
                    </Text>
                  </View>
                </View>

                <View style={{ width: '30%', flexDirection: 'row' }}>
                  <View style={{ width: '60%', padding: 2 }}>
                    <Text style={{ fontSize: 8, textAlign: 'left' }}>
                      {zoneB[0].sp}
                      {/* {zoneB
                      .map((a) => a.strName)
                      .filter(Boolean)
                      .join(', ')} */}
                    </Text>
                  </View>
                  <View style={{ width: '10%', padding: 2 }}>
                    <Text style={{ fontSize: 8, textAlign: 'center' }}>
                      {zoneB[0].sector}
                    </Text>
                  </View>
                  <View style={{ width: '20%', padding: 2 }}>
                    <Text style={{ fontSize: 8, textAlign: 'center' }}>
                      {zoneB[0].totalWeight}
                    </Text>
                  </View>
                  <View style={{ width: '10%', padding: 2 }}>
                    <Text style={{ fontSize: 8, textAlign: 'center' }}>
                      {noFishCaught ? data.length : zoneB[0].zonePlace}
                    </Text>
                  </View>
                </View>

                <View style={{ width: '15%', flexDirection: 'row' }}>
                  <View style={{ width: '50%', padding: 2 }}>
                    <Text style={{ fontSize: 8, textAlign: 'center' }}>
                      {item.totalGroupWeight || 0}
                    </Text>
                  </View>
                  <View style={{ width: '50%', padding: 2 }}>
                    <Text style={{ fontSize: 8, textAlign: 'center' }}>
                      {item.totalPlace || 0}
                    </Text>
                  </View>
                </View>
              </View>
            )
          })}
        </View>

        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 40,
          }}
        >
          <View
            style={{
              width: '35%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text style={{ fontSize: '8px', textAlign: 'center' }}>
              {administrator[0]?.surname +
                ' ' +
                administrator[0]?.name +
                ' ' +
                administrator[0]?.patronymic +
                ' (' +
                administrator[0]?.role +
                ', ' +
                administrator[0]?.rank +
                ') '}
            </Text>
          </View>
          <View
            style={{
              width: '35%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text style={{ fontSize: '8px', textAlign: 'center' }}>
              {administrator[1]?.surname +
                ' ' +
                administrator[1]?.name +
                ' ' +
                administrator[1]?.patronymic +
                ' (' +
                administrator[1]?.role +
                ', ' +
                administrator[1]?.rank +
                ') '}
            </Text>
          </View>
          <View
            style={{
              width: '20%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text style={{ fontSize: '8px', textAlign: 'center' }}>Дата</Text>
          </View>
        </View>

        <View style={styles.logoContainer}>
          {allLogo.map((item, index) => (
            <Image key={index} src={item.url} style={styles.logoSmall} />
          ))}
        </View>
      </Page>
    </Document>
  )
}

const ProtocolComGroup = ({ allLogo, mainLogo, data }) => {
  const [showPdfLink, setShowPdfLink] = useState(false)
  const [stage, setStage] = useState(null)
  const [totalFishCount, setTotalFishCount] = useState(null)
  const [totalWeight, setTotalWeight] = useState(null)
  const [averageFishWeight, setAverageFishWeight] = useState(null)
  const [biggestFish, setBiggestFish] = useState(null)
  const [isFinish, setIsFinish] = useState(null)
  const [tournament, setTournament] = useState(null)
  const [allLogos, setAllLogos] = useState([])
  const [administrator, setAdministrator] = useState([])
  const { id } = useParams()

  useEffect(() => {
    const allgetData = async () => {
      const resultsU = await getData('teams', 'id', id)
      if (resultsU.length > 0) {
        const { value } = resultsU[0]
        const teamsArray = Object.values(value)
        const filteredTeams = teamsArray.filter((teamEntry) => {
          const isValidTeam =
            teamEntry !== null &&
            typeof teamEntry === 'object' &&
            teamEntry.team?.status === 'Заявка одобрена' &&
            teamEntry.team?.status_location === 1
          return isValidTeam
        })
        const getnameSp = (team) => {
          console.log('[0][0][0][0]', team[0]?.fio)
          const sp1sports_category = team[0]?.sports_category
            ? ' (' + team[0]?.sports_category + ')'
            : ''
          const sp1 = team[0]?.fio ? team[0]?.fio : ''

          const sp2sports_category = team[1]?.sports_category
            ? ' (' + team[1]?.sports_category + ')'
            : ''
          const sp2 = team[1]?.fio ? ', ' + team[1]?.fio : ''

          const sp3sports_category = team[2]?.sports_category
            ? ' (' + team[2]?.sports_category + ')'
            : ''
          const sp3 = team[2]?.fio ? ', ' + team[2]?.fio : ''

          return (
            sp1 +
            sp1sports_category +
            sp2 +
            sp2sports_category +
            sp3 +
            sp3sports_category
          )
        }
        const resultsS = await getData('stage', 'id', id)
        if (resultsS.length > 0) {
          const { value } = resultsS[0]
          const stageArray = Object.values(value).filter(
            (teamEntry) => teamEntry !== null && typeof teamEntry === 'object'
          )

          const zones = { А: [], Б: [], В: [] }

          filteredTeams.forEach((teamObj) => {
            const teamData = teamObj.team
            if (teamData.zona && zones[teamData.zona]) {
              zones[teamData.zona].push({
                id: teamData.id,
                name: getname(teamData) || '',
                teamName: teamData.comand_name,
                totalWeight: calculateTotalWeight(teamData.id, stageArray),
                fishCount: calculateFishCount(teamData.id, stageArray),
                biggestFish: calculateBiggestFish(teamData.id, stageArray),
                zona: teamData.zona,
                sp: getnameSp(teamObj.athlete),
                sector: teamData.sector,
                communicationTeams: [
                  teamData.communication_team1,
                  teamData.communication_team2,
                ].filter(Boolean),
                disqualified: teamData.status === 'Снята',
              })
            }
          })
          console.log('zones', zones)

          const zoneStats = {}
          Object.keys(zones).forEach((zone) => {
            const teamsWithFish = zones[zone].filter(
              (team) => team.totalWeight > 0
            )
            zoneStats[zone] = {
              lastPlaceWithFish: teamsWithFish.length,
              totalTeams: zones[zone].length,
            }
          })

          Object.keys(zones).forEach((zone) => {
            const [normalTeams, disqualifiedTeams] = zones[zone].reduce(
              ([normal, disq], team) => {
                team.disqualified ? disq.push(team) : normal.push(team)
                return [normal, disq]
              },
              [[], []]
            )

            normalTeams.sort((a, b) => {
              if (a.totalWeight === 0 && b.totalWeight > 0) return 1
              if (a.totalWeight > 0 && b.totalWeight === 0) return -1
              if (a.totalWeight === 0 && b.totalWeight === 0) return 0

              if (b.totalWeight !== a.totalWeight)
                return b.totalWeight - a.totalWeight

              const avgA = a.fishCount > 0 ? a.totalWeight / a.fishCount : 0
              const avgB = b.fishCount > 0 ? b.totalWeight / b.fishCount : 0
              if (avgA !== avgB) return avgB - avgA

              return b.biggestFish - a.biggestFish
            })

            normalTeams.forEach((team, index) => {
              team.zonePlace =
                team.totalWeight === 0 ? normalTeams.length : index + 1
            })

            disqualifiedTeams.forEach((team) => {
              team.zonePlace = zones[zone].length + 3
            })
            console.log('normalTeamsnormalTeamsnormalTeams', normalTeams)

            zones[zone] = [...normalTeams, ...disqualifiedTeams]
          })

          const teamGroups = []
          const processedTeams = new Set()

          filteredTeams.forEach((teamObj) => {
            const teamId = teamObj.team.id
            if (processedTeams.has(teamId)) return

            const group = findConnectedTeams(teamId, filteredTeams)
            group.forEach((t) => processedTeams.add(t))

            const groupData = group.map((teamId) => {
              const team = findTeamInZones(teamId, zones)
              return {
                id: teamId,
                name: team?.name,
                zone: team?.zona,
                sector: team?.sector,
                place: team?.zonePlace,
                weight: team?.totalWeight,
                fishCount: team?.fishCount,
                biggestFish: team?.biggestFish,
                teamName: team?.teamName,
              }
            })

            const groupTeams = group
              .map((teamId) => findTeamInZones(teamId, zones))
              .filter(Boolean)

            let teamName = ''
            if (groupTeams.some((t) => t.teamName && t.teamName !== '')) {
              teamName = groupTeams.find(
                (t) => t.teamName && t.teamName !== ''
              )?.teamName
            } else {
              teamName = groupTeams.map((t) => t.name).join(' + ')
            }

            const totalPlace = groupData.reduce((sum, t) => sum + t.place, 0)
            const totalGroupWeight = groupData.reduce(
              (sum, t) => sum + (t.weight || 0),
              0
            )
            const totalGroupFishCount = groupData.reduce(
              (sum, t) => sum + (t.fishCount || 0),
              0
            )
            const groupBiggestFish = Math.max(
              ...groupData.map((t) => t.biggestFish || 0)
            )

            // Проверяем, что обе пары в команде не поймали рыбу
            const noFishCaught = groupData.every((team) => team.weight === 0)

            teamGroups.push({
              team: teamName,
              teams: groupData,
              totalPlace: totalPlace,
              totalGroupWeight,
              totalGroupFishCount,
              groupBiggestFish,
              athletes: getAllAthletes(group, filteredTeams),
              athletesByZone: groupTeams.reduce((acc, team) => {
                if (!team.zona) return acc // Пропускаем команды без зоны
                if (!acc[team.zona]) acc[team.zona] = []

                // Добавляем либо атлетов, либо всю команду
                if (team.athlete) {
                  acc[team.zona].push(
                    ...(Array.isArray(team.athlete)
                      ? team.athlete
                      : [team.athlete])
                  )
                } else {
                  acc[team.zona].push(team)
                }

                return acc
              }, {}),
              noFishCaught,
            })
          })

          // Сортируем команды
          teamGroups.sort((a, b) => {
            // Команды без рыбы идут в конец
            if (a.noFishCaught && !b.noFishCaught) return 1
            if (!a.noFishCaught && b.noFishCaught) return -1
            if (a.noFishCaught && b.noFishCaught) return 0

            // Остальные сортируем по стандартным правилам
            if (a.totalPlace !== b.totalPlace)
              return a.totalPlace - b.totalPlace
            if (b.totalGroupWeight !== a.totalGroupWeight)
              return b.totalGroupWeight - a.totalGroupWeight
            if (b.totalGroupFishCount !== a.totalGroupFishCount)
              return b.totalGroupFishCount - a.totalGroupFishCount
            return b.groupBiggestFish - a.groupBiggestFish
          })

          // Назначаем места с учетом команд без рыбы
          let currentRank = 1
          const rankedGroups = teamGroups.map((group, index) => {
            if (index > 0) {
              const prevGroup = teamGroups[index - 1]

              // Если текущая группа без рыбы - ставим последнее место
              if (group.noFishCaught) {
                currentRank = teamGroups.length
              }
              // Иначе стандартная логика
              else {
                const isTie =
                  prevGroup.totalPlace === group.totalPlace &&
                  prevGroup.totalGroupWeight === group.totalGroupWeight &&
                  prevGroup.totalGroupFishCount === group.totalGroupFishCount &&
                  prevGroup.groupBiggestFish === group.groupBiggestFish

                if (!isTie) currentRank = index + 1
              }
            }

            return {
              ...group,
              finalPlace: group.noFishCaught ? teamGroups.length : currentRank,
            }
          })

          setStage(rankedGroups)

          const resultsT = await getData('tournaments', 'id', id)
          if (resultsT.length > 0) {
            const { value } = resultsT[0]
            setIsFinish(value.status_cup === 'Турнир завершен')
            setTournament(value)
            setAllLogos(Object.values(value.sponsor || {}))
            setAdministrator(Object.values(value.administrator || []))
          }
        }
      }
    }

    if (showPdfLink) allgetData()
  }, [showPdfLink, id])

  function calculateTotalWeight(teamId, stages) {
    return stages[0]
      .filter((s) => s.teamId === teamId)
      .flatMap((s) => s.fishList || [])
      .reduce((sum, fish) => sum + (fish.weight || 0), 0)
  }

  function calculateFishCount(teamId, stages) {
    return stages[0]
      .filter((s) => s.teamId === teamId)
      .flatMap((s) => s.fishList || []).length
  }

  function calculateBiggestFish(teamId, stages) {
    const fishes = stages[0]
      .filter((s) => s.teamId === teamId)
      .flatMap((s) => s.fishList || [])
    return fishes.length ? Math.max(...fishes.map((f) => f.weight || 0)) : 0
  }

  function findConnectedTeams(teamId, teams, found = new Set()) {
    const team = teams.find((t) => t.team.id === teamId)
    if (!team || found.has(teamId)) return []

    found.add(teamId)
    const connections = [
      team.team.communication_team1,
      team.team.communication_team2,
    ].filter(Boolean)

    return [
      teamId,
      ...connections.flatMap((connId) =>
        findConnectedTeams(connId, teams, found)
      ),
    ].filter((v, i, a) => a.indexOf(v) === i)
  }

  function findTeamInZones(teamId, zones) {
    for (const zone of Object.values(zones)) {
      const team = zone.find((t) => t.id === teamId)
      if (team) return team
    }
    return null
  }

  function getAllAthletes(teamIds, teams) {
    return teamIds.flatMap((teamId) => {
      const team = teams.find((t) => t.team.id === teamId)
      return team ? team.athlete : []
    })
  }

  const getname = (teamData) => {
    return teamData?.preferred_name == 'en'
      ? teamData?.team_name_en
        ? teamData?.team_name_en
        : teamData?.team_name_ru
      : teamData?.team_name_ru
  }

  return (
    <div>
      {showPdfLink && stage && tournament ? (
        <PDFDownloadLink
          document={
            <TournamentProtocolGroupPDF
              allLogo={allLogos}
              mainLogo={getLogoUrl(tournament?.logocup)}
              data={stage}
              administrator={administrator}
              tournament={tournament}
              date={dateNowProtocol(new Date())}
              totalFishCount={totalFishCount}
              totalWeight={totalWeight}
              averageFishWeight={averageFishWeight}
              biggestFish={biggestFish}
              isfinish={isFinish}
            />
          }
          fileName={
            'командный_протокол_' + dateNowProtocol(new Date()) + '.pdf'
          }
          onClick={() => {
            setTimeout(() => setShowPdfLink(false), 0)
          }}
        >
          {({ loading }) => (
            <button
              style={{
                padding: '10px 20px',
                backgroundColor: loading ? '#ccc' : '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '16px',
              }}
              disabled={loading}
            >
              {loading ? 'Генерация PDF...' : 'Скачать '}
            </button>
          )}
        </PDFDownloadLink>
      ) : (
        <button
          onClick={() => setShowPdfLink(true)}
          style={{
            padding: '10px 20px',
            backgroundColor: '#4c7aaf',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
          }}
        >
          Командный протокол
        </button>
      )}
    </div>
  )
}

export default ProtocolComGroup
